import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HideSourceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hide_source"}/>
}
